var map = {
	"./analysis.isvg": "c999",
	"./analytics-1.isvg": "34b7",
	"./analytics.isvg": "a3e6",
	"./antiseptic.isvg": "17a3",
	"./baby.isvg": "ab36",
	"./bacteria.isvg": "0f1b",
	"./bar.isvg": "2627",
	"./barsplit.isvg": "88f1",
	"./blood.isvg": "89df",
	"./boxplot.isvg": "15c3",
	"./calendar.isvg": "ecf9",
	"./cannula.isvg": "c0db",
	"./car.isvg": "5717",
	"./catheter-prolong.isvg": "ae57",
	"./catheter-uri.isvg": "1db4",
	"./chamber.isvg": "6c56",
	"./chart.isvg": "a03a",
	"./chisquare.isvg": "d738",
	"./clipboard.isvg": "fe61",
	"./comparison.isvg": "ffe7",
	"./csv-1.isvg": "a886",
	"./csv.isvg": "2df3",
	"./datadock.isvg": "6d6e",
	"./dictionary.isvg": "07e1",
	"./doctor.isvg": "c31a",
	"./doughnut.isvg": "ddd2",
	"./dropper.isvg": "cfcb",
	"./event.isvg": "2343",
	"./file-1.isvg": "60c3",
	"./file.isvg": "8982",
	"./files.isvg": "5e0b",
	"./flow-chart.isvg": "10fc",
	"./folder.isvg": "40b5",
	"./form.isvg": "bb89",
	"./guide.isvg": "2c4f",
	"./hospital-1.isvg": "796f",
	"./hospital.isvg": "2f41",
	"./human-lungs.isvg": "4855",
	"./id.isvg": "8791",
	"./indicator-bar.isvg": "692e",
	"./laboratory.isvg": "26fc",
	"./list.isvg": "776c",
	"./lungs.isvg": "d22b",
	"./map.isvg": "9675",
	"./medical-history-1.isvg": "a2ad",
	"./medical-history.isvg": "0555",
	"./medical-report.isvg": "da41",
	"./mother.isvg": "763b",
	"./name.isvg": "0b20",
	"./newborn.isvg": "7532",
	"./notebook.isvg": "1fc9",
	"./open-box.isvg": "7d6e",
	"./oxygen-1.isvg": "8706",
	"./oxygen-mask.isvg": "480d",
	"./oxygen.isvg": "39dc",
	"./pbar.isvg": "5bef",
	"./pbarsplit.isvg": "5c6a",
	"./pdf.isvg": "fded",
	"./petri-dish.isvg": "6a3e",
	"./pipe.isvg": "ea6a",
	"./plaster.isvg": "5eea",
	"./polar.isvg": "bd26",
	"./poster.isvg": "8e74",
	"./presentation.isvg": "5013",
	"./registration.isvg": "b49a",
	"./repair.isvg": "e743",
	"./sanitizer.isvg": "749e",
	"./schedule.isvg": "2568",
	"./scoreboard.isvg": "2b69",
	"./siphon.isvg": "f4ab",
	"./speaker.isvg": "c0c3",
	"./stethoscope.isvg": "546d",
	"./swabs.isvg": "78e7",
	"./upload.isvg": "34ef",
	"./violin.isvg": "2dc1",
	"./youtube.isvg": "874d"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return Promise.resolve(/* lazy-once context */).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "91b1";
module.exports = webpackAsyncContext;